import { createContext } from 'react';
import { Activity } from '../../../types';

export type ActivityOptions = { [username: string]: Activity | undefined };

export const ActivityContext = createContext<ActivityOptions>({});
